import * as React from 'react';
import clx from 'classnames';
import { Typography } from 'antd';
const { Title } = Typography;
import './ProcedureSummaryTitle.scss';

export interface ProcedureSummaryTitleProps {
  children: React.ReactNode;
}

/**
 * Titolo della Domanda
 */
export function ProcedureSummaryTitle(props: ProcedureSummaryTitleProps) {
  return (
    <Title level={4} className={clx('procedure-summary-title', {})}>
      {props.children}
    </Title>
  );
}
